// import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
// import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
// import { NgForm } from '@angular/forms';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { AlertService } from '../_services/alert.service';
// import { ClientRegistration } from '../model/client.model';
// import { PerfectScrollbarComponent, PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
// import { DatatableComponent } from '@swimlane/ngx-datatable';
// import { NgBlockUI, BlockUI } from 'ng-block-ui';
// import { NgSelectDataService, City } from '../_services/ng-select-data.service';
// import { ClientService } from '../_services/domainservice/Client.service';
// import { RowStatuses } from '../model/masterModel/RowStatuses.model';
// import { SharedComponent } from '../../shared/shared.component';
// import { Guid } from '../_helpers/guid';
// import { Router } from '@angular/router';
// import { ProductService } from '../_services/domainservice/product.service';
// import { Account } from '../model/account.model';
// import { AccountService } from '../_services/domainservice/account.service';
// import { Product } from '../model/product.model';
// @Component({
//   selector: 'app-clientinfo',
//   templateUrl: './clientinfo.component.html',
//   styleUrls: ['./clientinfo.component.css']
// })
// export class ClientinfoComponent extends SharedComponent implements OnInit {
//   public breadcrumb: any;
//   cols!: any[];
//   action: string = 'Add';
//   @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
//   @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;
//   @ViewChild('clientForm', { static: false }) clientForm!: NgForm;
//   onlineSearch: boolean = false;
//   referralFromFriendOrFamilyMember: boolean = false;
//   socialMedia: boolean = false;
//   advertisement: boolean = false;
//   other: boolean = false;
//   ProductUID: Guid;

//   client: ClientRegistration = new ClientRegistration;
//   dateofBirth: Date;
//   date: Date;
//   registrationDate: Date;
//   joiningDate: Date;
//   deleteAccess: boolean = false;
//   fullcontrolAccess: boolean = false;
//   writeAccess: boolean = false;
//   readAccess: boolean = false;
//   harddeleteAccess: boolean = false;
//   addAccess: boolean = true;
//   ProductDetailsList: Array<Product>;
//   clientregistrationlist: any;
//   informationProvidedTheBestOfMyKnowledge: boolean = false;
//   ClientRegistrationID: any;
//   SelectedFile: File = null;
//   currentDate = new Date();
//   confidentialBusinessPurposes: boolean = false;
//   CommunicationAddr: string;
//   PermanentAddr: string;
//   logoChoosefile: string = "Choose file";
//   fileToUpload: File = null;
//   signatureChoosefile: string = "Choose file"
//   constructor(private modalService: NgbModal,
//     readonly clientService: ClientService,
//     readonly alertService: AlertService,
//     private spinner: NgxSpinnerService,
//     private dataService: NgSelectDataService,
//     private route: Router,
//     private productService: ProductService,
//     private accountService: AccountService,
//     private http: HttpClient
//   ) {
//     super();
//   }

//   ngOnInit() {

//     // this.deleteAccess = JSON.parse(localStorage.getItem('currentUser')).accessRole.delete;
//     // this.fullcontrolAccess = JSON.parse(localStorage.getItem('currentUser')).accessRole.fullControl;
//     // this.writeAccess = JSON.parse(localStorage.getItem('currentUser')).accessRole.write;
//     // this.readAccess = JSON.parse(localStorage.getItem('currentUser')).accessRole.read;
//     // this.harddeleteAccess = JSON.parse(localStorage.getItem('currentUser')).accessRole.hardDelete;
//     // this.breadcrumb = {
//     //   'mainlabel': 'Client',
//     //   'links': [
//     //     {
//     //       'name': 'Home',
//     //       'isLink': true,
//     //       'link': '/dashboard/sales'
//     //     },
//     //     {
//     //       'name': 'Manage Clients',
//     //       'isLink': true,
//     //       'link': '#'
//     //     },
//     //     {
//     //       'name': 'Clients',
//     //       'isLink': false
//     //     },
//     //     {
//     //       'name': 'Select',
//     //       'isLink': false
//     //     }
//     //   ]
//     // };


//     this.getmasterdata();
//   }

//   getToday(): string {
//     return new Date().toISOString().split('T')[0]
//   }
//   updateAddrs(e) {
//     this.CommunicationAddr = this.client.communicationAddress;
//     this.PermanentAddr = this.client.permanentAddress;
//     if (e) {
//       this.PermanentAddr = this.CommunicationAddr;
//       this.client.permanentAddress = this.PermanentAddr;
//     }
//     else {
//       this.client.permanentAddress = '';
//     }

//   }

//   getmasterdata() {
//     this.productService.getProduct().subscribe((getproductData): void => {
//       this.ProductDetailsList = getproductData;
//     })
//     // this.accountService.getAccount().subscribe((getaccountdetaildata: Array<Account>): void => {
//     //   this.clientregistrationlist = getaccountdetaildata;

//     // });
//     // //this.appservice.spinner.next(true);

//     // this.spinner.show();
//     // this.clientService.getClient().subscribe((data): void => {
//     //   this.spinner.hide();
//     //   this.ClientData = data;
//     //   this.temp2 = this.ClientData;
//     // },
//     //   (error: HttpErrorResponse): void => {
//     //     console.log(error);
//     //     this.alertService.error(error.message);
//     //     this.spinner.hide();
//     //   }
//     // );
//   }
//   uploadFile(event) {
//     this.SelectedFile = <File>event.target.files[0];
//   }
//   upload() {
//     const filedata = new FormData();
//     filedata.append('file', this.fileToUpload, this.fileToUpload.name);
//     this.clientService.commonUpload("ABGCommonFileUpload/" + this.client.companyName, "Logo", filedata).subscribe((): void => {
//     });
//   }
//   uploadSignature() {
//     const filedata = new FormData();
//     filedata.append('file', this.fileToUpload, this.fileToUpload.name);
//     this.clientService.commonUpload("ABGCommonFileUpload/" + this.client.companyName, "Signature", filedata).subscribe((): void => {
//     });
//   }
//   clientregistrationidgen() {
//     this.clientService.getClientMaxId().subscribe((data: ClientRegistration): void => {
//       this.ClientRegistrationID = data;
//     }, (error: HttpErrorResponse): void => {
//       this.client.clientRegistrationId = 1000;
//       console.log(error);
//     });
//   }

//   ViewPopup(Content, action, rowdata?: any) {
//     this.modalService.dismissAll();
//     this.action = action;
//     this.modalService.open(Content, { windowClass: 'animated fadeInDown', backdrop: 'static' });
//     setTimeout(() => {
//       document.getElementsByClassName('modal-backdrop')[0].removeAttribute("style");
//     }, 400);
//     if (this.action === 'Add') {
//       this.client = new ClientRegistration();
//       this.client.clientRegistrationUId = Guid.newGuid();
//       this.clientregistrationidgen();
//       //this.dateofBirth = null;
//       //this.date = null;
//       //this.registrationDate = null;
//       //this.joiningDate = null;
//     }
//     if (rowdata) {
//       this.client = rowdata;
//       this.logoChoosefile = this.client.logo.split('/')[this.client.logo.split('/').length - 1];
//       this.ProductUID = this.client.productUId;
//       this.client.dateofBirth = this.client.dateofBirth ? this.client.dateofBirth?.toString().slice(0, 10) : null;
//       this.client.date = this.client.date ? this.client.date?.toString().slice(0, 10) : null;
//       this.client.registrationDate = this.client.registrationDate ? this.client.registrationDate?.toString().slice(0, 10) : null;
//       this.client.joiningDate = this.client.joiningDate ? this.client.joiningDate?.toString().slice(0, 10) : null;
//       this.signatureChoosefile = this.client.signature.split('/')[this.client.signature.split('/').length - 1];
//     }
//   }

//   // updateFilter(event) {
//   //   const val = event.target.value.toLowerCase();
//   //   this.ClientData = [...this.temp2]; and here you have to initialize it with your data
//   //   this.temp = [...this.ClientData];
//   //   // filter our data
//   //   const temp = this.ClientData.filter(function (d) {
//   //     return d.companyName.toLowerCase().indexOf(val) !== -1 || !val;
//   //     return d.companyCertificateNumber.toLowerCase().indexOf(val) || !val;
//   //   });
//   //   // update the rows
//   //   this.ClientData = temp;
//   //   // Whenever the filter changes, always go back to the first page
//   //   this.table.offset = 0;

//   // }
//   GetProductUId(e) {
//     console.log(e.target.value)
//     this.ProductUID = e.target.value;
//   }

//   SaveClient(clientForm: NgForm) {
//     if (this.action == 'Delete') {
//       this.client.itemState = 3;
//       this.client.rowStatusUId = RowStatuses.Inactive;
//       this.client.productUId = this.ProductUID;

//       this.setAuditFields(this.client);
//       this.spinner.show();
//       this.clientService.mergeClient(this.client, this.action).subscribe((): void => {
//         this.spinner.hide();
//         this.modalService.dismissAll();
//         //this.getmasterdata();
//         this.alertService.success('Client Details Deleted successfully');
//         clientForm.reset();
//       },
//         (error: HttpErrorResponse): void => {
//           console.log(error);
//           this.alertService.error(error.message);
//           this.spinner.hide();
//         });

//     } else {

//       if (clientForm && clientForm.valid) {
//         this.client.itemState = this.action == 'Add' ? 1 : 2;
//         this.client.rowStatusUId = RowStatuses.Active;
//         this.client.signature = "/ABGCommonFileUpload/" + this.client.companyName + "/Signature/" + this.signatureChoosefile;
//         this.client.logo = "/ABGCommonFileUpload/" + this.client.companyName + "/Logo/" + this.logoChoosefile;
//         //this.client.emailAddress = localStorage.getItem('user');
//         this.client.clientRegistrationId = this.ClientRegistrationID;
//         this.client.onlineSearch = this.onlineSearch;
//         this.client.referralFromFriendOrFamilyMember = this.referralFromFriendOrFamilyMember;
//         this.client.socialMedia = this.socialMedia;
//         this.client.advertisement = this.advertisement;
//         this.client.other = this.other;
//         this.client.informationProvidedTheBestOfMyKnowledge = false;
//         this.client.productUId = this.ProductUID;
//         this.client.joiningDate = this.currentDate;
//         this.client.confidentialBusinessPurposes = false;
//         this.setAuditFields(this.client);
//         this.spinner.show();
//         this.clientService.mergeClient(this.client, this.action).subscribe((): void => {
//           this.spinner.hide();
//           this.modalService.dismissAll();
//           this.uploadSignature();
//           this.upload();
//           //this.getmasterdata();
//           //this.alertService.success('Client Details saved successfully');
//           //this.route.navigate(['/login']);
//           this.accountService.getAccount().subscribe((getaccountdetaildata: Array<Account>): void => {
//             this.clientregistrationlist = getaccountdetaildata;

//           });
//           if (this.clientregistrationlist?.filter(cli => cli.clientRegistrationUId === this.client.clientRegistrationUId).length > 0) {
//             clientForm.reset();
//           }
//            else {
//           this.route.navigate(['/abg/accountregistration'], { queryParams: { clientRegistrationUId: this.client.clientRegistrationUId } })
//            }
//           //clientForm.reset();
//         },
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//             this.alertService.error(error.message);
//             this.spinner.hide();
//           });
//       }
//       else {
//         this.alertService.warning('Enter All the Fields');
//       }
//     }
//   }
//   TransfertoAccountRegistration(clientRegistrationUId) {
//     this.route.navigate(['/abg/accountregistration'], { queryParams: { clientRegistrationUId: clientRegistrationUId } })
//   }
//   validateAccountRegistration(clientRegistrationUId): boolean {
//     if (this.clientregistrationlist?.filter(cli => cli.clientRegistrationUId === clientRegistrationUId).length > 0) {
//       return false;
//     }
//     else {
//       return true;
//     }
//   }
//   closePopup(clientForm: NgForm, Content) {
//     this.modalService.dismissAll();
//     if (clientForm.dirty) {
//       this.modalService.open(Content, { windowClass: 'animated fadeInDown', backdrop: 'static' });
//       setTimeout(() => {
//         document.getElementsByClassName('modal-backdrop')[0].removeAttribute("style");
//       }, 400);
//     } else {
//       //this.getmasterdata();
//     }
//   }
//   //progress: number;
//   //message: string;
//   //uploadFile = (files) => {
//   //  if (files.length === 0) {
//   //    return;
//   //  }
//   //  let fileToUpload = <File>files[0];
//   //  const formData = new FormData();
//   //  formData.append('file', fileToUpload, fileToUpload.name);

//   //  this.http.post('https://localhost:7027/api/ClientRegistrations/upload', formData, { reportProgress: true, observe: 'events' })
//   //    .subscribe({
//   //      next: (event) => {
//   //        if (event.type === HttpEventType.UploadProgress)
//   //          this.progress = Math.round(100 * event.loaded / event.total);
//   //        else if (event.type === HttpEventType.Response) {
//   //          this.message = 'Upload success.';
//   //          //this.onUploadFinished.emit(event.body);
//   //        }
//   //      },
//   //      error: (err: HttpErrorResponse) => console.log(err)
//   //    });
//   //}



//   onFileChange(files: FileList) {
//     this.logoChoosefile = Array.from(files)
//       .map(f => f.name)
//       .join(', ');
//     this.fileToUpload = files.item(0);



//     //if (event.target.files && event.target.files[0]) {
//     //  var reader = new FileReader();
//     //
//     //  reader.readAsDataURL(event.target.files[0]); // read file as data url
//     //
//     //  reader.onload = (event) => { // called once readAsDataURL is completed
//     //    this.url = event.target.result;
//     //  }
//     //}
//   }

//   onFileChangeSignature(files: FileList) {
//     this.signatureChoosefile = Array.from(files)
//       .map(f => f.name)
//       .join(', ');
//     this.fileToUpload = files.item(0);
//   }
// }


// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { SharedComponent } from '../../shared/shared.component';
// import { Guid } from '../_helpers/guid';
// import { AlertService } from '../_services/alert.service';
// import { ProductService } from '../_services/domainservice/product.service';
// import { ClientService } from '../_services/domainservice/Client.service';
// import { CompanyDetailsService } from '../_services/domainservice/companydetails.service';
// import { Product } from '../model/product.model';
// import { CompanyDetails } from '../model/companydetails.model';
// import { RowStatuses } from '../model/masterModel/RowStatuses.model';

// interface DocSlot {
//   key: 'logo' | 'gst' | 'pan' | 'registration' | 'udyam' | 'other';
//   label: string;
//   folder: string;           // upload sub-folder / type sent to commonUpload
//   imageOnly: boolean;
//   fileName: string;
//   file: File | null;
//   error: string;
// }


// @Component({
//   selector: 'app-clientinfo',
//   templateUrl: './clientinfo.component.html',
//   styleUrls: ['./clientinfo.component.css']
// })
// export class ClientinfoComponent extends SharedComponent implements OnInit {
//   form!: FormGroup;
//   step = 1;                         // 1 Company | 2 Contact | 3 Subscription | 4 Documents
//   readonly totalSteps = 4;
//   submitted = false;
//   loading = false;
//   errorMessage = '';
//   successMessage = '';

//   // Auto-generated, read-only identifiers
//   tenantId: string = Guid.newGuid().toString();
//   clientRegistrationUId: string = Guid.newGuid().toString();
//   clientRegistrationId: number | null = null;
//   registrationNumber = '';

//   products: Array<Product> = [];

//   companyTypes = ['Proprietorship', 'Partnership', 'LLP', 'Private Limited', 'Public Limited', 'Other'];
//   licenseTypes = ['Trial', 'Standard', 'Professional', 'Enterprise'];
//   subscriptionPlans = ['Monthly', 'Quarterly', 'Half-Yearly', 'Annual'];

//   // Document handling (kept outside the form group)
//   private static readonly MAX_BYTES = 5 * 1024 * 1024; // 5 MB
//   private static readonly DOC_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
//   private static readonly IMG_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

//   docs: DocSlot[] = [
//     { key: 'logo', label: 'Company Logo', folder: 'Logo', imageOnly: true, fileName: 'Choose file', file: null, error: '' },
//     { key: 'gst', label: 'GST Certificate', folder: 'GSTCertificate', imageOnly: false, fileName: 'Choose file', file: null, error: '' },
//     { key: 'pan', label: 'PAN Card', folder: 'PANCard', imageOnly: false, fileName: 'Choose file', file: null, error: '' },
//     { key: 'registration', label: 'Registration Certificate', folder: 'RegistrationCertificate', imageOnly: false, fileName: 'Choose file', file: null, error: '' },
//     { key: 'udyam', label: 'UDYAM Certificate', folder: 'UdyamCertificate', imageOnly: false, fileName: 'Choose file', file: null, error: '' },
//     { key: 'other', label: 'Other Documents', folder: 'Other', imageOnly: false, fileName: 'Choose file', file: null, error: '' }
//   ];

//   // Which controls belong to which step (used to validate before Next).
//   private readonly stepControls: { [step: number]: string[] } = {
//     1: ['companyName', 'companyLegalName', 'companyRegistrationNumber', 'companyType', 'industry',
//       'gstNumber', 'panNumber', 'cinNumber', 'msmeUdyamNumber', 'iecNumber', 'companyWebsite',
//       'companyEmail', 'companyPhone', 'alternatePhone', 'companyAddress', 'city', 'state', 'country', 'pinCode'],
//     2: ['contactFullName', 'contactDesignation', 'contactMobile', 'contactEmail', 'alternateContact'],
//     3: ['productUId', 'licenseType', 'subscriptionPlan', 'registrationDate', 'renewalDate', 'status']
//   };

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly route: ActivatedRoute,
//     private readonly router: Router,
//     private readonly spinner: NgxSpinnerService,
//     private readonly alertService: AlertService,
//     private readonly productService: ProductService,
//     private readonly clientService: ClientService,
//     private readonly companyService: CompanyDetailsService
//   ) { super() }

//   ngOnInit(): void {
//     const paramClientUId = this.route.snapshot.queryParamMap.get('clientRegistrationUId');
//     if (paramClientUId) { this.clientRegistrationUId = paramClientUId; }
//     const paramTenant = this.route.snapshot.queryParamMap.get('tenantId');
//     if (paramTenant) { this.tenantId = paramTenant; }

//     this.buildForm();
//     this.loadProducts();
//     this.generateIds();
//   }

//   private buildForm(): void {
//     const today = new Date().toISOString().split('T')[0];
//     this.form = this.fb.group({
//       // Company
//       companyName: ['', Validators.required],
//       companyLegalName: [''],
//       companyRegistrationNumber: [''],
//       companyType: [''],
//       industry: [''],
//       gstNumber: ['', [Validators.pattern(/^[0-9A-Z]{15}$/)]],
//       panNumber: ['', [Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]$/)]],
//       cinNumber: [''],
//       msmeUdyamNumber: [''],
//       iecNumber: [''],
//       companyWebsite: [''],
//       companyEmail: ['', [Validators.required, Validators.email]],
//       companyPhone: ['', [Validators.required, Validators.pattern(/^[0-9]{10,15}$/)]],
//       alternatePhone: ['', [Validators.pattern(/^[0-9]{10,15}$/)]],
//       companyAddress: [''],
//       city: [''],
//       state: [''],
//       country: ['India'],
//       pinCode: ['', [Validators.pattern(/^[1-9][0-9]{5}$/)]],
//       // Contact
//       contactFullName: ['', Validators.required],
//       contactDesignation: [''],
//       contactMobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
//       contactEmail: ['', [Validators.email]],
//       alternateContact: ['', [Validators.pattern(/^[0-9]{10}$/)]],
//       // Subscription
//       productUId: ['', Validators.required],
//       licenseType: ['Standard'],
//       subscriptionPlan: ['Annual'],
//       registrationDate: [today, Validators.required],
//       renewalDate: [''],
//       status: ['Active', Validators.required]
//     });
//   }

//   private loadProducts(): void {
//     this.productService.getProduct().subscribe(
//       (data: Array<Product>): void => { this.products = data || []; },
//       (error: HttpErrorResponse): void => { console.log(error); }
//     );
//   }

//   /** Fetch next sequential business id + build a human-readable registration number. */
//   private generateIds(): void {
//     this.clientService.getClientMaxId().subscribe(
//       (data: any): void => {
//         this.clientRegistrationId = typeof data === 'number' ? data : (data?.clientRegistrationId ?? 1000);
//         this.registrationNumber = this.buildRegistrationNumber(this.clientRegistrationId);
//       },
//       (error: HttpErrorResponse): void => {
//         this.clientRegistrationId = 1000;
//         this.registrationNumber = this.buildRegistrationNumber(this.clientRegistrationId);
//         console.log(error);
//       }
//     );
//   }

//   private buildRegistrationNumber(id: number): string {
//     const y = new Date().getFullYear();
//     return `KG-REG-${y}-${String(id).padStart(6, '0')}`;
//   }

//   get f() { return this.form.controls; }

//   // ---------- Wizard navigation ----------
//   next(): void {
//     if (this.step < this.totalSteps && this.isStepValid(this.step)) {
//       this.errorMessage = '';
//       this.step++;
//     }
//   }

//   prev(): void {
//     if (this.step > 1) { this.step--; }
//   }

//   goTo(step: number): void {
//     // allow jumping back freely, forward only if prior steps are valid
//     if (step <= this.step || this.isRangeValid(this.step, step - 1)) {
//       this.step = step;
//     }
//   }

//   private isRangeValid(from: number, to: number): boolean {
//     for (let s = from; s <= to; s++) {
//       if (!this.isStepValid(s)) { return false; }
//     }
//     return true;
//   }

//   private isStepValid(step: number): boolean {
//     const names = this.stepControls[step] || [];
//     let ok = true;
//     names.forEach(n => {
//       const c = this.form.get(n);
//       if (c) {
//         c.markAsTouched();
//         if (c.invalid) { ok = false; }
//       }
//     });
//     if (!ok) { this.errorMessage = 'Please correct the highlighted fields before continuing.'; }
//     return ok;
//   }

//   // ---------- Document handling ----------
//   onFileSelected(event: Event, slot: DocSlot): void {
//     const input = event.target as HTMLInputElement;
//     const file = input.files && input.files.length ? input.files[0] : null;
//     slot.error = '';

//     if (!file) {
//       slot.file = null;
//       slot.fileName = 'Choose file';
//       return;
//     }

//     const allowed = slot.imageOnly ? ClientinfoComponent.IMG_TYPES : ClientinfoComponent.DOC_TYPES;
//     if (allowed.indexOf(file.type) === -1) {
//       slot.error = slot.imageOnly ? 'Only JPG / PNG images are allowed.' : 'Allowed types: PDF, JPG, PNG.';
//       slot.file = null; slot.fileName = 'Choose file'; input.value = '';
//       return;
//     }
//     if (file.size > ClientinfoComponent.MAX_BYTES) {
//       slot.error = 'File must be 5 MB or smaller.';
//       slot.file = null; slot.fileName = 'Choose file'; input.value = '';
//       return;
//     }

//     slot.file = file;
//     slot.fileName = file.name;
//   }

//   private slot(key: DocSlot['key']): DocSlot {
//     return this.docs.find(d => d.key === key) as DocSlot;
//   }

//   // ---------- Submit ----------
//   submit(): void {
//     this.submitted = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     if (this.form.invalid) {
//       this.form.markAllAsTouched();
//       this.errorMessage = 'Please complete all required fields.';
//       // jump to first invalid step
//       for (let s = 1; s <= 3; s++) {
//         if (!this.isStepValid(s)) { this.step = s; return; }
//       }
//       return;
//     }
//     if (this.slot('logo').error || this.slot('gst').error || this.slot('pan').error) {
//       this.errorMessage = 'Please fix the document errors before submitting.';
//       this.step = 4;
//       return;
//     }

//     const model = this.buildModel();
//     this.loading = true;
//     this.spinner.show();

//     this.companyService.mergeCompanyDetails(model, 'Add').subscribe(
//       (): void => {
//         this.uploadAllDocuments(model.companyName);
//         this.spinner.hide();
//         this.loading = false;
//         this.successMessage = 'Company details saved. Redirecting to sign in...';
//         setTimeout(() => this.router.navigate(['/login']), 1400);
//       },
//       (error: HttpErrorResponse): void => {
//         this.spinner.hide();
//         this.loading = false;
//         this.errorMessage = error?.error?.message || 'Could not save company details. Please try again.';
//         console.log(error);
//       }
//     );
//   }

//   private buildModel(): CompanyDetails {
//     const v = this.form.value;
//     const m = new CompanyDetails();

//     m.companyDetailsUId = Guid.newGuid();
//     m.tenantId = this.tenantId as any;
//     m.clientRegistrationUId = this.clientRegistrationUId as any;
//     m.clientRegistrationId = this.clientRegistrationId || undefined;
//     m.registrationNumber = this.registrationNumber;

//     m.companyName = v.companyName;
//     m.companyLegalName = v.companyLegalName;
//     m.companyRegistrationNumber = v.companyRegistrationNumber;
//     m.companyType = v.companyType;
//     m.industry = v.industry;
//     m.gstNumber = v.gstNumber || undefined;
//     m.panNumber = v.panNumber || undefined;
//     m.cinNumber = v.cinNumber || undefined;
//     m.msmeUdyamNumber = v.msmeUdyamNumber;
//     m.iecNumber = v.iecNumber;
//     m.companyWebsite = v.companyWebsite;
//     m.companyEmail = v.companyEmail;
//     m.companyPhone = v.companyPhone;
//     m.alternatePhone = v.alternatePhone;
//     m.companyAddress = v.companyAddress;
//     m.city = v.city;
//     m.state = v.state;
//     m.country = v.country || 'India';
//     m.pinCode = v.pinCode;

//     m.contactFullName = v.contactFullName;
//     m.contactDesignation = v.contactDesignation;
//     m.contactMobile = v.contactMobile;
//     m.contactEmail = v.contactEmail;
//     m.alternateContact = v.alternateContact;

//     m.productUId = v.productUId;
//     m.licenseType = v.licenseType;
//     m.subscriptionPlan = v.subscriptionPlan;
//     m.registrationDate = v.registrationDate;
//     m.renewalDate = v.renewalDate || undefined;
//     m.status = v.status;

//     // Server persists the authoritative paths; we send the computed paths for reference.
//     const base = `/CompanyFileUpload/${v.companyName}`;
//     m.companyLogoPath = this.slot('logo').file ? `${base}/Logo/${this.slot('logo').fileName}` : undefined;
//     m.gstCertificatePath = this.slot('gst').file ? `${base}/GSTCertificate/${this.slot('gst').fileName}` : undefined;
//     m.panCardPath = this.slot('pan').file ? `${base}/PANCard/${this.slot('pan').fileName}` : undefined;
//     m.registrationCertificatePath = this.slot('registration').file ? `${base}/RegistrationCertificate/${this.slot('registration').fileName}` : undefined;
//     m.udyamCertificatePath = this.slot('udyam').file ? `${base}/UdyamCertificate/${this.slot('udyam').fileName}` : undefined;
//     m.otherDocumentsPath = this.slot('other').file ? `${base}/Other/${this.slot('other').fileName}` : undefined;

//     m.rowStatusUId = RowStatuses.Active as any;
//     m.isActive = true;
//     m.isDeleted = false;
//     m.itemState = 1; // Add

//     return m;
//   }

//   private uploadAllDocuments(companyName: string): void {
//     this.docs.forEach(d => {
//       if (d.file) {
//         const fd = new FormData();
//         fd.append('file', d.file, d.file.name);
//         this.companyService.commonUpload(companyName, d.folder, fd).subscribe(
//           (): void => { },
//           (error: HttpErrorResponse): void => { console.log(`Upload failed for ${d.label}`, error); }
//         );
//       }
//     });
//   }

//   changeDetails(): void {
//     this.router.navigate(['/register'], { queryParams: { clientRegistrationUId: this.clientRegistrationUId } });
//   }
// }


import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '../_services/domainservice/account.service';

/**
 * ClientInfoComponent — NEW (Login-Test-Report.md Issue #1 fix).
 *
 * Login.ts routes here whenever a login succeeds for a user with no `clientRegistrationUId`
 * (`"No tenant on the account yet -> onboarding"`, `this.router.navigate(['/clientinfo'])`) — but no
 * `/clientinfo` route/component existed, so that branch also silently bounced back to `/login` via
 * the wildcard route (same root cause as Issue #1's other 3 missing screens).
 *
 * Field set is a deliberately-trimmed subset of Registration.ts's `companyForm` (the only place a
 * "company info" shape is confirmed in this project) — just the fields that matter for identifying an
 * organisation, since this user already has an account and only needs to attach a tenant to it.
 *
 * FIXED (Login-Test-Report.md Section 7.4 gap, closed): submission goes through
 * `AccountService.completeOnboarding()`, which now calls a real, authenticated
 * `api/ABGTechnologysAccounts/CompleteOnboarding` action (see that method's header comment in
 * account.service.ts). On success the response's `clientRegistrationUId` is merged into the
 * `currentUser`/`user` localStorage records — mirroring Login.ts's own storeSessionAndRoute() — so the
 * dashboard this component redirects to (and anything else reading `currentUser`) sees the
 * newly-provisioned tenant immediately, without requiring the user to sign in again.
 */
@Component({
  selector: 'app-clientinfo',
  templateUrl: './clientinfo.component.html',
  styleUrls: ['./clientinfo.component.css'],
})
export class ClientinfoComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  loading = false;
  errorMessage = '';
  successMessage = '';

  companyTypes = ['Proprietorship', 'Partnership', 'Private Limited', 'Public Limited', 'LLP', 'HUF', 'Trust', 'Society', 'Other'];
  industries = ['Retail', 'Manufacturing', 'IT / Software', 'Healthcare', 'Education', 'Textile / Garment', 'Hospitality', 'Logistics', 'Construction', 'Other'];

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly accountService: AccountService,
  ) { }

  ngOnInit(): void {
    // currentUser was already written to localStorage by Login.ts's setUserInStorage() before
    // navigating here, so pre-fill whatever contact details we already have.
    const raw = localStorage.getItem('currentUser');
    const user = raw ? this.safeJsonParse(raw) : {};

    this.form = this.fb.group({
      companyName: ['', Validators.required],
      companyType: [''],
      industry: [''],
      companyEmail: [user?.email || '', [Validators.required, Validators.email]],
      companyPhone: ['', [Validators.required, Validators.minLength(10)]],
      companyAddress: [''],
      city: [''],
      state: [''],
      country: ['India'],
      pinCode: ['', [Validators.pattern(/^[1-9][0-9]{5}$/)]],
      contactFullName: [user?.name || '', Validators.required],
    });
  }

  get f() { return this.form.controls; }

  submit(): void {
    this.submitted = true;
    this.errorMessage = '';
    this.successMessage = '';
    if (this.form.invalid) { return; }

    this.loading = true;
    const raw = localStorage.getItem('currentUser');
    const user = raw ? this.safeJsonParse(raw) : {};

    const payload = {
      userId: user?.userId ?? null,
      ...this.form.value,
    };

    this.accountService.completeOnboarding(payload).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.successMessage = 'Organization details submitted. Redirecting...';

        // Merge the newly-provisioned tenant id into currentUser so the dashboard (and anything else
        // reading it) has ClientRegistrationUId immediately — see this component's header comment.
        const clientRegistrationUId = res?.clientRegistrationUId ?? null;
        if (clientRegistrationUId) {
          const updatedUser = { ...user, clientRegistrationUId };
          localStorage.setItem('user', JSON.stringify(updatedUser));
          localStorage.setItem('currentUser', JSON.stringify(updatedUser));
          localStorage.setItem('CurrentClientUId', clientRegistrationUId);
        }

        setTimeout(() => this.router.navigate(['/dashboard']), 1200);
      },
      error: () => {
        this.loading = false;
        this.errorMessage = 'Could not save your organization details. Please try again, or contact support if this keeps happening.';
      },
    });
  }

  private safeJsonParse(value: string): any {
    try { return JSON.parse(value); } catch { return {}; }
  }
}




